import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import {
    normalizeMetadataReports,
    normalizeQuestionnaireReports,
} from "../../helpers/reportExport";
import { EntityRecordsTable, KeyValueTable, SectionTitle } from "../../shared";
import QuestionnaireReports from "./QuestionnaireReports";

const REPORT_METADATA_COLUMNS = [
    { key: "index", label: "#", width: "6%" },
    { key: "title", label: "Report", width: "30%" },
    { key: "type", label: "Type", width: "18%" },
    { key: "requestDate", label: "Request Date", width: "16%" },
    { key: "submissionDate", label: "Submission Date", width: "16%" },
    { key: "status", label: "Status", width: "14%" },
];

const ReportsSection = ({ supplierData = {}, meta }) => {
    const reports = Array.isArray(supplierData?.reports) ? supplierData.reports : [];
    const questionnaireReports = normalizeQuestionnaireReports(reports);
    const metadataReports = normalizeMetadataReports(reports);

    const reportSummaryRows = [
        { title: "Open Requests", details: metadataReports.filter((report) => report?.status === "OPEN").length || 0 },
        { title: "Reports Submitted", details: metadataReports.filter((report) => report?.status === "SUBMITTED").length || 0 },
        { title: "Total Number of Reports", details: metadataReports.length || 0 },
    ];

    const reportRecords = metadataReports.map((report, index) => ({
        id: report?.id || `report-${index}`,
        index: index + 1,
        title: report?.title || "External Company Report",
        type: report?.type || report?.reportType,
        requestDate: report?.requestDate,
        submissionDate: report?.submissionDate,
        status: report?.status,
    }));

    const sectionTitle = (
        <SectionTitle
            title={meta?.title || "Reports"}
            number={meta?.number}
            anchorId={meta?.anchorId}
        />
    );

    return (
        <View style={styles.wordSectionContent}>
            {questionnaireReports.length > 0 ? (
                <View>
                    {sectionTitle}
                    <QuestionnaireReports reports={questionnaireReports} />
                </View>
            ) : metadataReports.length > 0 ? (
                <>
                    <KeyValueTable
                        leading={sectionTitle}
                        rows={reportSummaryRows}
                        titleColumnLabel="Metric"
                        detailsColumnLabel="Value"
                    />
                    <EntityRecordsTable
                        columns={REPORT_METADATA_COLUMNS}
                        records={reportRecords}
                    />
                </>
            ) : (
                <EntityRecordsTable
                    leading={sectionTitle}
                    columns={REPORT_METADATA_COLUMNS}
                    records={[]}
                />
            )}
        </View>
    );
};

export default withNamespaces()(ReportsSection);
